import { Component, inject, Input } from '@angular/core';
import { IDonor } from '../../../models/IDonor';
import { NgFor } from '@angular/common';
import { AbsoluteMediaUriService } from '../../../services/absolute-media-uri.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-donors',
  imports: [NgFor],
  templateUrl: './donors.component.html',
  styleUrl: './donors.component.scss'
})
export class DonorsComponent {
  @Input() donors: IDonor[] = [];

  protected readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);
  private readonly sanitizer = inject(DomSanitizer);



  protected getSafeUri(uri: string | undefined | null): SafeResourceUrl {
    if (uri != undefined && uri != null) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(uri)
    }
    return "";
  }
}




